<template>
  <div
    class="c-chat__usersSearchResult"
    :class="{ '-show': show }">
    <template v-if="chatStore.usersSearchQuery.length >= 3">
      <div
        v-if="chatStore.colleaguesAreLoading"
        class="o-flex -row -alignCenter -center u-marginTop3">
        <LoadingSpinner />
      </div>
      <div
        v-else-if="chatStore.usersSearchResult.length"
        class="c-grid u-marginTop3 u-marginBottom3 c-chat__usersList">
        <button
          v-for="user in chatStore.usersSearchResult"
          :key="user.id"
          class="c-button -flat o-flex -alignCenter -justifyStart -gap2 c-chat__userSearchListItem"
          @click="openUserThread(user)">
          <UserAvatar
            :user="user"
            small />
          <div
            class="t-body3"
            v-html="highlightSearchQueryPart(user.displayName)" />
        </button>
      </div>
      <div
        v-else-if="showNoUsersFound"
        class="t-body3 u-colorDarkMediumEmphasis u-marginTop2 u-marginBottom2 u-marginRight4 u-marginLeft4">
        <p>{{ $t('chat.no_users_found') }}</p>
      </div>
    </template>

    <template v-else>
      <div
        class="t-h6 u-marginRight4 u-marginLeft4 u-marginBottom2 u-marginTop3">
        {{ $t('chat.users') }}
      </div>
      <div
        v-if="chatStore.randomColleaguesAreLoading"
        class="o-flex -row -alignCenter -center u-marginTop3">
        <LoadingSpinner />
      </div>
      <div
        v-else
        class="c-chat__usersColleagues">
        <UserColleagueCard
          v-for="user in chatStore.colleagues"
          :key="user.id"
          :user="user"
          @click="openUserThread(user)" />
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'

import LoadingSpinner from '@/components/LoadingSpinner.vue'
import chatApi from '@/modules/chat/api/chat'
import { useChatStore } from '@/modules/chat/chatStore'
import UserAvatar from '@/modules/chat/components/DialogSidebar/UserAvatar.vue'
import UserColleagueCard from '@/modules/chat/components/DialogSidebar/UserColleagueCard.vue'

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['openUserThread'])

const chatStore = useChatStore()
const openUserThread = async (user) => {
  const thread = await chatApi.getChatThread(user.id)
  const participant = thread.participant
  participant.isOnline = user.isOnline
  participant.threadId = thread.id
  participant.azure_chat_thread_id = thread.azure_chat_thread_id
  participant.lastMessage = {}
  thread.participant = participant
  if (!chatStore.myChatThreads.find((chatThread) => chatThread.id === thread.id)) {
    chatStore.myChatThreads.push(thread)
    chatStore.resortThreads = true
  }

  emit('openUserThread', thread.participant)
  chatStore.usersSearchQuery = ''
}

watch(() => props.show, (newValue) => {
  if (newValue && chatStore.colleagues.length === 0) {
    chatStore.fetchRandomUsers()
  }
}, { immediate: true })

const highlightSearchQueryPart = (text) => {
  if (!chatStore.usersSearchQuery) {
    return text
  }
  const regex = new RegExp(chatStore.usersSearchQuery, 'gi')
  return text.replace(regex, (match) => `<b>${match}</b>`)
}

const showNoUsersFound = computed(() => {
  return chatStore.usersSearchQuery.length >= 3
  && !chatStore.usersSearchResult.length
  && !chatStore.colleaguesAreLoading
  && !chatStore.isSearchingUsers
})

</script>

<style scoped lang="scss">
@import '@/assets/scss/config';

.c-grid {
  display: grid;
}

.c-chat__userSearchListItem {
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  border-radius: $spacing-3;
  padding: $spacing-2 $spacing-2;
  margin: 0 $spacing-2;

  &:hover {
    background-color: $color-primary_transparent_10;
  }
}
</style>
